import { FC } from "react";
import { EPI_CHART_AXIS_TEXT_COLOR } from "./epiColors";
import './EpiBarChart.scss';

interface Props {
	labels: string[];
	values: number[];
	percentages: number[];
	colors: string[];
	emptyMessage: string;
}

const EpiBarChart: FC<Props> = ({ labels, values, percentages, colors, emptyMessage }) => {
	const hasData = values.length > 0 && labels.length > 0;

	if (!hasData) {
		return (
			<div className="epi-bar-chart epi-bar-chart-vazio">
				<span>{emptyMessage}</span>
			</div>
		);
	}

	const maxValue = Math.max(1, ...values);

	return (
		<div className="epi-bar-chart">
			{labels.map((label, index) => (
				<div className="epi-bar-chart-linha" key={label}>
					<span className="epi-bar-chart-rotulo" style={{ color: EPI_CHART_AXIS_TEXT_COLOR }}>
						{label}
					</span>
					<div className="epi-bar-chart-trilha">
						<div
							className="epi-bar-chart-barra"
							style={{
								width: `${(values[index] * 100) / maxValue}%`,
								backgroundColor: colors[index]
							}}
						/>
					</div>
					<span className="epi-bar-chart-valor">
						{formatValue(values[index], percentages[index])}
					</span>
				</div>
			))}
		</div>
	);
};

function formatValue(value: number, percentage: number) {
	const formattedPercentage = (percentage ?? 0).toFixed(1).replace('.', ',');
	return `${value} (${formattedPercentage}%)`;
}

export default EpiBarChart;
